import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { currentLanguage } from './algolia';

if (!i18next.isInitialized) {
  i18next.use(initReactI18next).init({
    supportedLngs: ['de', 'en', 'fr', 'es', 'nl'],
    lng: currentLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    resources: {},
    partialBundledLanguages: true,
    load: 'languageOnly',
    react: {
      bindI18nStore: 'added',
    },
  });
}

export default i18next;
